import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ userType, isOpen = false, onClose = () => {} }) => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  useEffect(() => {
    const selector = `a[href='${activeLink}']`;
    const el = document.querySelector(selector);
    if (isOpen && el) el.focus();
  }, [isOpen, activeLink]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const L = ({ to, children }) => (
    <li>
      <Link to={to} className={activeLink === to ? 'active' : ''} onClick={onClose}>
        {children}
      </Link>
    </li>
  );

  const Section = ({ title, children }) => (
    <>
      {title && <div className="sectionTitle">{title}</div>}
      <ul>{children}</ul>
      <hr />
    </>
  );

  const ManualLink = () => (
    <ul className="manualMenu">
      <L to="/enduser/manual">マニュアル</L>
    </ul>
  );

  const MenuAdmin = () => (
    <>
      <Section title="会員メニュー">
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
        <L to="/enduser/usersettings">アカウント設定</L>
      </Section>

      <Section title="管理メニュー">
        <L to="/admin/eventmanagement">イベント管理</L>
        <L to="/admin/usermanagement">ユーザー管理</L>
        <L to="/admin/dogmanagement">犬種管理</L>
        <L to="/admin/systemsetting">システム設定</L>
      </Section>
    </>
  );

  const MenuOperator = () => (
    <>
      <Section title="会員メニュー">
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
        <L to="/enduser/usersettings">アカウント設定</L>
      </Section>

      <Section title="管理メニュー">
        <L to="/operator/operatorevent">イベント管理</L>
      </Section>
    </>
  );

  const MenuEnduser = () => (
    <>
      <Section title="会員メニュー">
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
        <L to="/enduser/usersettings">アカウント設定</L>
      </Section>
    </>
  );

  const MenuSystem = () => (
    <>
      <Section title="会員メニュー">
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
        <L to="/enduser/usersettings">アカウント設定</L>
      </Section>

      <Section title="オペレーターメニュー">
        <L to="/operator/operatorevent">イベント管理</L>
      </Section>

      <Section title="管理メニュー">
        <L to="/admin/eventmanagement">イベント管理</L>
        <L to="/admin/usermanagement">ユーザー管理</L>
        <L to="/admin/dogmanagement">犬種管理</L>
        <L to="/admin/systemsetting">システム設定</L>
      </Section>

      <Section title="システムメニュー">
        <L to="/system/settings">設定</L>
      </Section>
    </>
  );

  const MenuGuest = () => (
    <>
      <Section title="メニュー">
        <L to="/login">ログイン</L>
      </Section>
    </>
  );

  const renderMenu = () => {
    if (userType === 'system') return <MenuSystem />;
    if (userType === 'admin') return <MenuAdmin />;
    if (userType === 'operator') return <MenuOperator />;
    if (userType === 'enduser') return <MenuEnduser />;
    return <MenuGuest />;
  };

  return (
    <div className="sidebar-container">
      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebarMain">
          {renderMenu()}
        </div>

        {userType && (
          <div className="sidebarBottom">
            <ManualLink />
          </div>
        )}
      </nav>

      <div className={`sidebar-backdrop ${isOpen ? 'show' : ''}`} onClick={onClose} />
    </div>
  );
};

export default Sidebar;